import { render, staticRenderFns } from "./EditClientModal.vue?vue&type=template&id=235bd0e9&"
import script from "./EditClientModal.vue?vue&type=script&lang=ts&"
export * from "./EditClientModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput} from 'quasar'
component.options.components = Object.assign({QInput}, component.options.components || {})
